<template>
  <images-list
    :schema="schema"
    :mediaURL="mediaURL"
    :queryString="queryString"
    @error="handleError"
  ></images-list>
</template>

<script>
import { ImagesList } from '@witkac/vue-images';

import { uploadMixin } from '../../mixins/upload';

// @vuese
// @group Components/Forms
// Input na obrazki
export default {
  mixins: [uploadMixin],
  components: { ImagesList }
};
</script>
